export enum SessionStorageKey {
  registerEmail = 'registerEmail',
  desktopOptimizedDialogSeen = 'desktopOptimizedDialogSeen',
  pathBeforeAuthRedirect = 'pathBeforeAuthRedirect',
  isMobileAppWebView = 'isMobileAppWebView',
}
